import Controller from '@ember/controller';
import { service } from '@ember/service';

import { Button } from '@repo/design-system-kit/components/button/button';
import { Disclaimer } from '@repo/design-system-kit/components/disclaimer/disclaimer';
import * as Sentry from '@sentry/ember';
import { task } from 'ember-concurrency';
import window from 'ember-window-mock';

import { jsURL } from 'register-partners-js/constants/hosts';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { ErrorInfo } from 'register-partners-js/utils/error-info';
import { fetchNavigationOrganizations } from 'register-partners-js/utils/fetch-navigation-organizations';

import styles from './styles.module.css';

export default class CredentialsSuccessController extends Controller {
  mainLayout = MainLayout;

  @service intl;
  @service networkManager;
  @service segment;
  @service toastFlashMessages;
  @service router;

  button = Button;
  disclaimerInline = Disclaimer.Inline;

  get organizationNameFirstLetter() {
    return this.model.organization.get('name').split('')[0].toUpperCase();
  }

  get disclaimerText() {
    if (this.model.registration.isEmbedded) {
      return this.intl.t('existing-company.qonto-embed.success-screen.disclaimer');
    }

    return this.intl.t('existing-company.fast-track.success-screen.disclaimer');
  }
  styles = styles;

  submitTask = task(async () => {
    let registration = this.model.registration;

    this.segment.track('onboarding_partner_register_overview_cta_clicked');
    if (registration.isMicroEnterpriseCreationThoughLegalPlace) {
      try {
        let organization = await registration.organization;
        let organizations = await fetchNavigationOrganizations(this.networkManager);
        let org = organizations.find(o => o.id === organization.id);
        window.location.href = `${jsURL}/organizations/${org.slug}`;
      } catch (error) {
        this.toastFlashMessages.toastError(this.intl.t('errors.internal-server-error'));
        let errorInfo = ErrorInfo.for(error);
        if (errorInfo.shouldSendToSentry) {
          Sentry.captureException(error);
        }
      }
    } else {
      this.router.transitionTo('registration.phone-number');
    }
  });
}
